module.exports = __webpack_public_path__ + "static/w-teladoc-demand-generation-e2c09a0580f143668c577bc98f49ffa1.webp";